import React from 'react';
import { IApiService } from 'Services/base';
import {
  ListPublicKeysRequest,
  ListPublicKeysResponse,
} from './requests';

export interface ISettingsServiceApi {
  getFirstPublicKey(): Promise<string | null>;
}

const extractPublicKeyFromItem = ( item: unknown ): string | null => {
  if ( typeof item === 'string' ) {
    return item;
  }
  if ( !item || typeof item !== 'object' ) {
    return null;
  }
  const record = item as Record<string, unknown>;
  const value = record.publicKey ?? record.public_key ?? record.key ?? record.value;
  return typeof value === 'string' ? value : null;
};

const extractPublicKeyFromList = ( value: unknown ): string | null => {
  if ( !Array.isArray( value ) ) {
    return null;
  }
  for ( const item of value ) {
    const candidate = extractPublicKeyFromItem( item );
    if ( candidate ) {
      return candidate;
    }
  }
  return null;
};

const extractPublicKeyFromResponse = ( response: unknown ): string | null => {
  if ( !response || typeof response !== 'object' ) {
    return null;
  }
  const data = response as Record<string, unknown>;
  return extractPublicKeyFromList( data.items );
};

export class SettingsServiceApi implements ISettingsServiceApi {
  protected api: IApiService;

  constructor( api: IApiService ) {
    this.api = api;
  }

  async getFirstPublicKey(): Promise<string | null> {
    try {
      const response = await this.api.request<ListPublicKeysResponse>( new ListPublicKeysRequest() );
      return extractPublicKeyFromResponse( response );
    } catch {
      return null;
    }
  }
}

export const SettingsServiceApiContext: React.Context<ISettingsServiceApi> =
  React.createContext( undefined as any );

export const useSettingsServiceApi = (): ISettingsServiceApi =>
  React.useContext( SettingsServiceApiContext );
